// Types
import { TTimezoneResponse } from "../types";

// Constants
import { GOOGLE_API } from "@/Constants/api";
import { MILLISECONDS } from "../constants";

function getGoogleApiTimezoneUrl(lat: number, lng: number, format: "json" | "xml" = "json") {
	const { VITE_APP_GOOGLE_MAPS_API_KEY: apiKey } = import.meta.env;
	const secondTimestamp = Math.floor(Date.now() / MILLISECONDS);

	return `${GOOGLE_API.timezone}/${format}?location=${lat},${lng}&timestamp=${secondTimestamp}&key=${apiKey}`;
}

async function requestTimezone(geoLocation: GeoLocation) {
	try {
		const { latitude: lat, longitude: lng } = geoLocation;

		const url = getGoogleApiTimezoneUrl(lat, lng);
		const response = await fetch(url, { method: "GET" });

		const data = (await response.json()) as TTimezoneResponse;

		if (data.status !== "OK") {
			console.log("Error fetching timezone:", data.errorMessage);
		}

		return data;
	} catch (error) {
		console.log("Error fetching timezone:", error);
		return { status: "TRY_CATCH_ERROR", errorMessage: (error as Error).message } as TTimezoneResponse;
	}
}

export { requestTimezone };
